<template>
  <PageWrapper>
    <template v-slot:content>
      <div class="custom-table" v-if="isShowPage">
        <el-button type="primary" size="small" class="el-icon-plus custom-btn" @click="handleAdd">新增客户分类</el-button>
        <el-table border fit  highlight-current-row class="customer-table" :data="list">
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="分类名称" prop="classname"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope)"
                         class="el-icon-edit-outline"
              >
                编辑
              </el-button>
              <el-popconfirm
                iconColor="red"
                @confirm="handleDelete(scope.row,scope.$index)"
                title="确认删除此条数据吗？"
              >
                <el-button slot="reference" type="danger" size="small" class="el-icon-delete">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]" :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
      </div>
      <el-empty description="暂无权限查看数据" v-else class="customer-category_empty"/>
      <Edit :dialog="dialog" :form-data="editFormData"  @submit="handleSubmit" :type="type" @close="handleClose" />
    </template>
  </PageWrapper>
</template>
<script>
import { defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue';
import Edit from "./edit.vue";
import request from '@/utils/request';
import { Message } from 'element-ui';


export default defineComponent({
  components: {PageWrapper,Edit},
  setup() {

    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20,
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref("")
    const editFormData = ref({})
    const list = ref([])
    const keyId = ref(null)
    const isShowPage = ref(false)


    const handleAdd = () => {
      dialog.value = true;
      type.value = "add";
      editFormData.value = {}
    }
    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getCustomerCategory()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getCustomerCategory()
    }

    const handleEdit = (scope) => {
      dialog.value = true
      type.value = "edit"
      const {classname,wt,id} = scope.row
      keyId.value = id
      editFormData.value = {classname, wt}
    }

    const handleDelete = (scope, index) =>{
      request({
        url: 'customer_type_delete.yy',
        method: 'post',
        data: { id: scope.id }
      }).then(res =>{
        if(res.code == 200) deleteRow(index)
      }).catch(err =>{
        Message({message: err,type: 'error'})
      })
    }

    const deleteRow = (index)=> {
      list.value.splice(index, 1)
    }

    onMounted(() => {
      getCustomerCategory()
    })

    const instance = getCurrentInstance()
    const store = instance.proxy.$store.getters.name
    const getCustomerCategory = () => {
      request({
        url: 'customer_type.yy',
        method: 'post',
        data: {username: store},
      }).then((res) => {
        const {code, data,msg} = res
        if(code == 200){
          list.value = data
          isShowPage.value = true
        }else if(code == 400){
          isShowPage.value = false
          Message({type:"error", message: msg})
        }
      })
    }

    const handleSubmit = (form) => {
      let data;
      if(type.value === 'add') {
        data = request({
          url: 'customer_type_add.yy',
          method: 'post',
          data: form
        })
      }else{
        data = request({
          url: 'customer_type_update.yy',
          method: 'post',
          data: {id: keyId.value,...form}
        })
      }
      data.then(res=>{
        if(res.code == 200){
           dialog.value = false
           getCustomerCategory()
        }
      })
    }

    const handleClose = () => {
      dialog.value = false
      editFormData.value = {}
    }

    return {
      isShowPage,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      list,
      keyId,
      handleClose,
      handleAdd,
      pageSizeChange,
      pageCurrentChange,
      handleSubmit,
      handleEdit,
      handleDelete,
      deleteRow
    };
  }
})
</script>
<style scoped>
.el-icon-edit-outline {
  margin-right: 10px;
}
.el-icon-delete {
  span {
    margin-left: 4px;
  }
}
.customer-category_empty {
  height: calc(100vh - 130px);
}
</style>

